import { useState } from 'react';

export default function ArticleSidebar() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !name) return;

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      formData.append('name', name);

      const response = await fetch('https://readdy.ai/api/form/d4mv9iit20jieso0q630', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString()
      });

      if (response.ok) {
        setSubmitMessage('Đang chuyển hướng...');
        setEmail('');
        setName('');
        setTimeout(() => {
          window.location.href = 'https://thankyou.phuotmy.com/';
        }, 500);
      } else {
        setSubmitMessage('Có lỗi xảy ra. Vui lòng thử lại.');
      }
    } catch (error) {
      setSubmitMessage('Có lỗi xảy ra. Vui lòng thử lại.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const popularTours = [
    {
      id: 1,
      title: 'Tour Bờ Đông: New York - Washington - Philadelphia',
      duration: '7 ngày 6 đêm',
      price: '45,900,000',
      image: 'https://public.readdy.ai/ai/img_res/fd7868b2e3051471dd9ee9c0f0839fea.jpg',
      badge: 'Bán chạy'
    },
    {
      id: 2,
      title: 'Tour Bờ Tây: Los Angeles - Las Vegas - Grand Canyon',
      duration: '8 ngày 7 đêm',
      price: '52,900,000',
      image: 'https://readdy.ai/api/search-image?query=Grand%20Canyon%20Arizona%20dramatic%20landscape%20with%20red%20rock%20formations%20at%20golden%20hour%2C%20vast%20natural%20wonder%2C%20clear%20blue%20sky%2C%20stunning%20American%20Southwest%20scenery%2C%20professional%20nature%20photography&width=400&height=300&seq=tour-west-1&orientation=landscape',
      badge: 'Hot'
    },
    {
      id: 3,
      title: 'Tour Florida: Miami - Orlando - Key West',
      duration: '6 ngày 5 đêm',
      price: '38,900,000',
      image: 'https://readdy.ai/api/search-image?query=Miami%20Beach%20Florida%20with%20turquoise%20ocean%20water%20and%20white%20sand%20beach%2C%20palm%20trees%2C%20Art%20Deco%20buildings%2C%20sunny%20tropical%20paradise%2C%20vibrant%20coastal%20scenery%2C%20professional%20travel%20photography&width=400&height=300&seq=tour-florida-1&orientation=landscape',
      badge: null
    }
  ];

  return (
    <div className="sticky top-20 space-y-6">
      {/* Quick Navigation */}
      <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
        <h3 className="text-base font-bold text-gray-900 mb-4 flex items-center gap-2">
          <i className="ri-list-check text-teal-600 text-xl"></i>
          Nội dung bài viết
        </h3>
        <ul className="space-y-3">
          {[
            { label: 'Tổng quan Visa B1/B2', icon: 'ri-file-list-3-line' },
            { label: 'Hồ sơ cần thiết', icon: 'ri-file-text-line' },
            { label: 'Hướng dẫn phỏng vấn', icon: 'ri-question-answer-line' },
            { label: 'Mẹo từ chuyên gia', icon: 'ri-lightbulb-line' }
          ].map((item, index) => (
            <li key={index}>
              <a
                href="#"
                className="flex items-center gap-2 text-sm text-gray-700 hover:text-teal-600 transition-colors group cursor-pointer"
              >
                <i className={`${item.icon} text-gray-400 group-hover:text-teal-600`}></i>
                <span>{item.label}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* Newsletter Subscription */}
      <div className="bg-gradient-to-br from-teal-600 to-blue-700 rounded-xl p-6 text-white">
        <div className="w-12 h-12 flex items-center justify-center mb-4">
          <i className="ri-mail-send-line text-4xl"></i>
        </div>
        
        <h3 className="text-lg font-bold mb-2">
          Nhận thêm mẹo Visa qua email
        </h3>
        <p className="text-sm text-white/90 mb-4">
          Đăng ký để nhận hướng dẫn chi tiết và cập nhật mới nhất về visa Mỹ
        </p>
        
        <form onSubmit={handleSubscribe} data-readdy-form id="article-subscription">
          <input
            type="text"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Họ và tên"
            required
            className="w-full px-4 py-3 rounded-lg text-gray-900 text-sm mb-3 focus:outline-none focus:ring-2 focus:ring-white"
          />
          
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email của bạn"
            required
            className="w-full px-4 py-3 rounded-lg text-gray-900 text-sm mb-3 focus:outline-none focus:ring-2 focus:ring-white"
          />
          
          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-white text-teal-700 px-6 py-3 rounded-lg text-sm font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-50"
          >
            {isSubmitting ? 'Đang gửi...' : 'Đăng ký ngay'}
          </button>
        </form>

        {submitMessage && (
          <div className={`mt-3 text-sm ${submitMessage.includes('thành công') || submitMessage.includes('gửi') ? 'text-white' : 'text-red-200'}`}>
            {submitMessage}
          </div>
        )}
      </div>

      {/* Popular Tours */}
      <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
        <h3 className="text-base font-bold text-gray-900 mb-4 flex items-center gap-2">
          <i className="ri-flight-takeoff-line text-orange-600 text-xl"></i>
          Tour Mỹ phổ biến
        </h3>
        
        <div className="space-y-4">
          {popularTours.map((tour) => (
            <div key={tour.id} className="group cursor-pointer">
              <div className="relative w-full h-40 rounded-lg overflow-hidden mb-3">
                {tour.badge && (
                  <div className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full z-10 whitespace-nowrap">
                    {tour.badge}
                  </div>
                )}
                <img
                  src={tour.image}
                  alt={tour.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                />
              </div>
              <h4 className="text-sm font-bold text-gray-900 mb-2 line-clamp-2 group-hover:text-teal-600 transition-colors">
                {tour.title}
              </h4>
              <div className="flex items-center justify-between text-xs text-gray-600 mb-2">
                <span className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  {tour.duration}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-lg font-bold text-orange-600">
                  {tour.price}đ
                </span>
                <button className="bg-teal-600 text-white px-4 py-2 rounded-lg text-xs font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
                  Xem chi tiết
                </button>
              </div>
              {tour.id < popularTours.length && (
                <div className="border-b border-gray-200 mt-4"></div>
              )}
            </div>
          ))}
        </div>

        <button className="w-full mt-4 bg-gray-100 text-gray-900 px-6 py-3 rounded-lg text-sm font-semibold hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer">
          Xem tất cả Tour Mỹ →
        </button>
      </div>

      {/* Related Articles */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Bài viết liên quan</h3>
        <div className="space-y-4">
          <a href="/car-rental-guide" className="flex gap-3 group cursor-pointer">
            <div className="w-16 h-16 flex-shrink-0 rounded-lg overflow-hidden">
              <img 
                alt="Thuê xe du lịch Mỹ" 
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" 
                src="https://readdy.ai/api/search-image?query=Modern%20car%20rental%20service%20in%20America%20with%20various%20vehicles%2C%20professional%20rental%20office%2C%20clean%20business%20environment%2C%20customer%20service%20atmosphere%2C%20bright%20lighting&width=120&height=120&seq=related-1&orientation=squarish" 
              />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-gray-900 line-clamp-2 group-hover:text-teal-600 transition-colors">
                Hướng dẫn thuê xe du lịch Mỹ
              </h4>
            </div>
          </a>

          <a href="/travel-insurance-guide" className="flex gap-3 group cursor-pointer">
            <div className="w-16 h-16 flex-shrink-0 rounded-lg overflow-hidden">
              <img 
                alt="Bảo hiểm du lịch Mỹ" 
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" 
                src="https://readdy.ai/api/search-image?query=Travel%20insurance%20documentation%20and%20protection%20concept%2C%20professional%20insurance%20papers%2C%20medical%20coverage%20symbols%2C%20clean%20office%20setting%2C%20trustworthy%20atmosphere&width=120&height=120&seq=related-2&orientation=squarish" 
              />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-gray-900 line-clamp-2 group-hover:text-teal-600 transition-colors">
                Bảo hiểm du lịch Mỹ toàn tập
              </h4>
            </div>
          </a>

          <a href="/american-food-guide" className="flex gap-3 group cursor-pointer">
            <div className="w-16 h-16 flex-shrink-0 rounded-lg overflow-hidden">
              <img 
                alt="Ẩm thực Mỹ: Những món ăn phải thử" 
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" 
                src="https://readdy.ai/api/search-image?query=Delicious%20American%20cuisine%20food%20photography%20featuring%20burgers%20and%20classic%20dishes%2C%20appetizing%20presentation%20on%20wooden%20table%2C%20natural%20lighting%2C%20restaurant%20quality%20food%20styling%2C%20mouth-watering%20appearance&width=120&height=120&seq=related-3&orientation=squarish" 
              />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-gray-900 line-clamp-2 group-hover:text-teal-600 transition-colors">
                Ẩm thực Mỹ: Những món ăn phải thử
              </h4>
            </div>
          </a>

          <a href="/public-transport-guide" className="flex gap-3 group cursor-pointer">
            <div className="w-16 h-16 flex-shrink-0 rounded-lg overflow-hidden">
              <img 
                alt="Hướng dẫn sử dụng phương tiện công cộng" 
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" 
                src="https://readdy.ai/api/search-image?query=Modern%20American%20public%20transportation%20system%20with%20subway%20trains%2C%20clean%20transit%20stations%2C%20professional%20urban%20infrastructure%2C%20efficient%20city%20transport%2C%20contemporary%20design&width=120&height=120&seq=related-4&orientation=squarish" 
              />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-gray-900 line-clamp-2 group-hover:text-teal-600 transition-colors">
                Hướng dẫn sử dụng phương tiện công cộng tại Mỹ
              </h4>
            </div>
          </a>

          <a href="/money-saving-tips" className="flex gap-3 group cursor-pointer">
            <div className="w-16 h-16 flex-shrink-0 rounded-lg overflow-hidden">
              <img 
                alt="Mẹo tiết kiệm khi du lịch Mỹ" 
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" 
                src="https://readdy.ai/api/search-image?query=Money%20saving%20concept%20with%20American%20dollars%20and%20piggy%20bank%2C%20budget%20planning%20setup%2C%20financial%20planning%20atmosphere%2C%20clean%20background%2C%20professional%20styling&width=120&height=120&seq=related-5&orientation=squarish" 
              />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-gray-900 line-clamp-2 group-hover:text-teal-600 transition-colors">
                Mẹo tiết kiệm khi du lịch Mỹ
              </h4>
            </div>
          </a>

          <a href="/new-york-attractions" className="flex gap-3 group cursor-pointer">
            <div className="w-16 h-16 flex-shrink-0 rounded-lg overflow-hidden">
              <img 
                alt="10 địa điểm không thể bỏ lỡ ở New York" 
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" 
                src="https://readdy.ai/api/search-image?query=Iconic%20New%20York%20City%20skyline%20with%20Empire%20State%20Building%20and%20Manhattan%20architecture%2C%20urban%20landscape%20photography%2C%20classic%20NYC%20view%2C%20professional%20cityscape%2C%20clear%20sky&width=120&height=120&seq=related-6&orientation=squarish" 
              />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-gray-900 line-clamp-2 group-hover:text-teal-600 transition-colors">
                10 địa điểm không thể bỏ lỡ khi đến New York
              </h4>
            </div>
          </a>
        </div>
      </div>

      {/* Contact CTA */}
      <div className="bg-gradient-to-br from-orange-500 to-red-600 rounded-xl p-6 text-white">
        <div className="w-12 h-12 flex items-center justify-center mb-4">
          <i className="ri-customer-service-2-line text-4xl"></i>
        </div>
        <h3 className="text-lg font-bold mb-2">Cần hỗ trợ?</h3>
        <p className="text-sm text-white/90 mb-4">
          Đội ngũ chuyên gia của chúng tôi sẵn sàng tư vấn miễn phí về visa và tour du lịch Mỹ
        </p>
        <button className="w-full bg-white text-orange-600 px-6 py-3 rounded-lg text-sm font-semibold hover:bg-gray-50 transition-colors flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer">
          <i className="ri-phone-line text-lg"></i>
          Liên hệ ngay
        </button>
      </div>
    </div>
  );
}